// frontend/src/componentes/SideBar.js

import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import MenuLateral from "./MenuLateral";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setToastMessage, setToastType } from "../redux/reducer";
import { Alert, Snackbar } from "@mui/material";
import { checkAuthenticate, finalizarSessao } from "../services/api/auth";
import { sanitizeToken } from "../services/api/postgrest";

const bypassAuth = process.env.REACT_APP_BYPASS_AUTH === "true";
const SIDEBAR_LOG_PREFIX = "[SideBar]";
const SESSION_LOG_PREFIX = "[SideBar][Sessao]";

export const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [esconderMenu, setEsconderMenu] = useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const dispatch = useDispatch();
  const toastMessage = useSelector(
    (state) => state.persistedReducer.toastMessage
  );
  const toastType = useSelector((state) => state.persistedReducer.toastType);
  const token = useSelector((state) => state.persistedReducer.token);
  const snackbarRef = useRef(null);

  const verificaAuthenticacao = async () => {
    if (bypassAuth) {
      return;
    }

    try {
      const sanitizedToken = sanitizeToken(token);

      if (!sanitizedToken) {
        console.warn(
          `${SESSION_LOG_PREFIX} Token ausente durante verificação, redirecionando`
        );
        navigate("/login");
        return;
      }

      await checkAuthenticate(sanitizedToken);
    } catch (error) {
      console.warn(`${SESSION_LOG_PREFIX} Sessão inválida detectada`, error);
      try {
        await finalizarSessao(token);
      } catch (logoutError) {
        console.warn(`${SESSION_LOG_PREFIX} Falha ao finalizar sessão`, logoutError);
      }
      navigate("/login");
    }
  };

  // TODAS AS ROTAS PRIVADAS DEVEM ESTAR NESSE ARRAY PARA O MENU APARECER
  const rotasPrivadas = [
    "/inicio",
    "/referencias",
    "/avisoPrivacidade",
    "/termoUso",
    "/sobre",
    "/contato",
  ];

  useEffect(() => {
    if (rotasPrivadas.some((rota) => location.pathname.includes(rota))) {
      console.info(`${SIDEBAR_LOG_PREFIX} Verificando sessão para rota privada`, {
        pathname: location.pathname,
      });
      verificaAuthenticacao();
      setEsconderMenu(false);
    } else {
      setEsconderMenu(true);
    }
  }, [location.pathname, navigate, token]);

  useEffect(() => {
    if (toastMessage) {
      setOpenAlert(true);
    }
  }, [toastMessage]);

  return (
    <>
      {!esconderMenu && (
        <div style={{ position: "absolute", zIndex: 9999 }}>
          <Snackbar
            ref={snackbarRef}
            TransitionProps={{ nodeRef: snackbarRef }}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={openAlert}
            autoHideDuration={5000}
            onClose={() => {
              setOpenAlert(false);
              dispatch(setToastMessage(""));
              dispatch(setToastType(""));
            }}
          >
            <Alert
              onClose={() => {
                setOpenAlert(false);
                dispatch(setToastMessage(""));
              }}
              severity={toastType || "success"}
              sx={{ width: "100%" }}
            >
              {toastMessage}
            </Alert>
          </Snackbar>
          <Header />
          {/* <MenuLateral /> */}
        </div>
      )}
    </>
  );
};
